import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingComponent = (delay) => (
  <Box
    data-testid="loading-container"
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="200px"
  >
    <CircularProgress sx={{ color: "#006699" }} />
  </Box>
);

export default LoadingComponent;